/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { I18nService } from '@dm/core';
import { FeatureConfig } from 'app/config/feature';
import { type Observable } from 'rxjs';

import { InfigoService } from '../../../infigo.service';
import { SourceEnumService } from '../../../source-enum.service';
import { RefreshComponent } from '../../RefreshComponent';

@Component({
    selector: 'app-logic-port-base-info',
    templateUrl: './logic-port-base-info.component.html',
})
export class LogicPortBaseInfoComponent extends RefreshComponent {
    @Input() item;
    detail: any = {};
    loading = true;
    baseInfo;

    constructor(
        public infigoService: InfigoService,
        public i18n: I18nService,
        public enumService: SourceEnumService,
        public changeDetectorRef: ChangeDetectorRef,
    ) {
        super();
        const I18N = i18n.get;
        // 运行状态、激活状态、数据协议
        // IP、子网掩码/前缀、网关
        // 主端口/当前端口
        const enumGet = enumService.get.bind(enumService, 'LOGICPORT');
        this.baseInfo = [
            {
                title: I18N('common.runningStatus_column'),
                key: 'RUNNINGSTATUS',
                enumMap: enumGet('RUNNINGSTATUS'),
            },
            {
                title: I18N('protection.vstore_hyperMetroDomain_task_view_activeStatus_lab'),
                key: 'OPERATIONALSTATUS',
                enumMap: enumGet('OPERATIONALSTATUS'),
            },
            {
                title: I18N('system.logicPort_task_create_dataProtocol_label'),
                key: 'SUPPORTPROTOCOL',
                enumMap: enumGet('SUPPORTPROTOCOL'),
            },
            {
                title: I18N('system.hardware_term_IP_column'),
                key: ['IPV4ADDR', 'IPV6ADDR'],
            },
            {
                title: I18N('system.dataProtection_dirReplication_term_subnetMaskPrefix_label'),
                key: ['IPV4MASK', 'IPV6MASK'],
            },
            {
                title: I18N('system.hardware_term_gateway'),
                key: ['IPV4GATEWAY', 'IPV6GATEWAY'],
            },
            {
                title: I18N('system.logicPort_task_view_primaryPort_label'),
                key: 'HOMEPORTNAME',
            },
            ...(FeatureConfig.IsHideLogicPortCurrentPort ? [] : [
                {
                    title: I18N('system.logicPort_task_view_currentPort_label'),
                    key: 'CURRENTPORTNAME',
                },
            ]),
        ];
    }

    requestInfo(): Observable<any> {
        return this.infigoService.getLogicPort(this.item.actionParams);
    }

    handleRequest(value: any): void {
        this.detail = value.data;
        this.loading = false;
        this.clearTimer();
        this.updateLoading = false;
        this.changeDetectorRef.detectChanges();
    }
}
